import { connectorApiClient } from '@/shared/api/core/axios-instance';

import type { ConnectorTypesResponse } from '@/entities/connector/types';

export const getConnectorTypesApi = async (): Promise<ConnectorTypesResponse> => {
  const { data } = await connectorApiClient.get<ConnectorTypesResponse>('/connector-types');
  return data;
};
